// extracted by mini-css-extract-plugin
module.exports = {"bubble":"styles_bubble__1L1wO","active":"styles_active__rEKcJ"};